import { CartItem } from 'shared/types/cart';
import { getSavedAmount } from 'shared/components/CartProducts/component/CartRevampProductCard/helpers';
import { getResolvedProductTagType } from 'shared/components/CartProducts/component/CartRevampProductCard/helpers/cardPresentation';

export function getCartProductPrimaryTag(item: CartItem): string | null {
  return getResolvedProductTagType(item);
}

/** One entry per cart line item for root-level product_tags (empty string when no resolved tag). */
export function getRootLevelProductTag(item: CartItem): string {
  return getCartProductPrimaryTag(item) ?? '';
}

export function getCartRevampProductAnalyticsFields(item: CartItem) {
  const primaryTag = getCartProductPrimaryTag(item);

  return {
    product_tags: primaryTag ? [primaryTag] : [],
    savings: getSavedAmount(item) ?? 0,
    offers_available_count: item.offerCommunication?.availableOfferIds?.length ?? 0,
    offers_applied_count: item.offerCommunication?.appliedOfferIds?.length ?? 0,
  };
}
